// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { JsonValueSchema } from '../inputTypeSchemas/JsonValueSchema'

/////////////////////////////////////////
// PDF TEMPLATE SCHEMA
/////////////////////////////////////////

export const PdfTemplateSchema = z.object({
  id: z.string(),
  tenantId: z.string().nullable(),
  name: z.string(),
  description: z.string().nullable(),
  logoS3Key: z.string().nullable(),
  primaryColor: z.string(),
  secondaryColor: z.string(),
  accentColor: z.string(),
  fontFamily: z.string(),
  fontS3Key: z.string().nullable(),
  headerContent: JsonValueSchema.nullable(),
  footerContent: JsonValueSchema.nullable(),
  sections: JsonValueSchema,
  isDefault: z.boolean(),
  requirePassword: z.boolean(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type PdfTemplate = z.infer<typeof PdfTemplateSchema>

export default PdfTemplateSchema;
